module.exports = __webpack_public_path__ + "static/media/vectuel.cbfb3dfb.svg";